//@ flow
import { put, fork, takeLatest, select } from "redux-saga/effects";
import moment from "moment";
import {
  ID_TIPO_JANELA_DIAS_UTEIS,
  FORMATO_DATA_BANCO,
  FORMATO_DATA_API,
} from "../model";
import { getDataBaseSelecionada } from "../state";
import { takeFetchRemoteData } from "../util";

export function* obterDatasSelecaoJanelaSaga({ api }) {
  yield takeFetchRemoteData("datasSelecaoJanela", function*(action): any {
    const {
      meta: {
        properties: { selecaoJanela, tipoJanelaSelecionada },
        resolve,
        reject,
      },
    } = action;

    try {
      const endpoint =
        tipoJanelaSelecionada === ID_TIPO_JANELA_DIAS_UTEIS
          ? api.obterDatasUteisPeriodoJanela
          : api.obterMesesPeriodoJanela;

      const datas = yield endpoint(
        moment(selecaoJanela.dataBase, FORMATO_DATA_BANCO).format(
          FORMATO_DATA_API
        ),
        selecaoJanela
      );

      yield put(resolve(datas));
    } catch (error) {
      yield put(reject(error));
    }
  });
}

export function* alteracaoDataBase({ frameApi }) {
  yield takeLatest(
    ["SELECIONAR_DATA_BASE", "SELECIONAR_DATA_BASE_DEFAULT"],
    function*(action): any {
      const dataBase = yield select(getDataBaseSelecionada);
      frameApi.salvarDataBase(dataBase.format(FORMATO_DATA_BANCO));
    }
  );
}

export default function* datasSaga({ api, frameApi }) {
  yield fork(obterDatasSelecaoJanelaSaga, { api });
  yield fork(alteracaoDataBase, { frameApi });
}
